/**
 * useRepositoryLazy Hook
 *
 * Provides on-demand (lazy) repository resolution.
 * Uses centralized repositoryResolver from data-access.
 * Useful when the repository is only needed for specific actions.
 *
 * @example
 * const { getRepository, isReady } = useRepositoryLazy<Tool>('Tool');
 *
 * const handleSave = async () => {
 *   const repo = await getRepository();
 *   await repo.save(tool);
 * };
 */
import { useCallback } from 'react';
import { repositoryResolver } from '@rammetec/data-access';
import { useRepositoryResolver } from './RepositoryResolverContext.js';
export function useRepositoryLazy(entityName) {
    const { isReady } = useRepositoryResolver();
    const getRepository = useCallback(async () => {
        if (!isReady) {
            throw new Error(`[useRepositoryLazy] Resolver not ready. ` +
                `Cannot get repository for "${entityName}".`);
        }
        return repositoryResolver.resolve(entityName);
    }, [entityName, isReady]);
    return {
        getRepository,
        isReady,
    };
}
//# sourceMappingURL=useRepositoryLazy.js.map